module.exports = __webpack_public_path__ + "static/media/marxeed_logo.8de8d24b.png";